var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"ma-7 pa-5",attrs:{"height":"90%"}},[_c('p',{staticClass:"text-center q-display-3 q_dark_gray--text",staticStyle:{"padding-top":"10%"}},[_vm._v("SSO to carrier to run a quote")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }